(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('OfferStatusDeleteController',OfferStatusDeleteController);

    OfferStatusDeleteController.$inject = ['$uibModalInstance', 'entity', 'OfferStatus'];

    function OfferStatusDeleteController($uibModalInstance, entity, OfferStatus) {
        var vm = this;
        vm.offerStatus = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            OfferStatus.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
